export enum StatusCode {
  OK = 200,
  CREATED = 201,
}
